import { EVENT_FIELDS } from "../../constants/analytics.es.js";
import { convertProfileToAnalyticsPayload } from "./pageUtils.es.js";
import { getBrowserID } from "./getBrowserID.es.js";
import { hashEmail } from "./hashUtils.es.js";
import { p as parseCookies } from "../../../cookies-04bd2321.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
import "../../constants/profileFields.es.js";
import "../../../utils/logger.es.js";
import "../../../v4-88c20f3b.js";
const extractIds = async (payload) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  const cookies = parseCookies();
  const leadId = ((_a = payload.properties.profile) == null ? void 0 : _a.leadUUID) || ((_b = payload.properties.profile) == null ? void 0 : _b.id);
  const profile = convertProfileToAnalyticsPayload(payload.properties.profile);
  const picked = pickFields(
    [EVENT_FIELDS.CEREBRO_PID, EVENT_FIELDS.FDR_APPLICANT_ID],
    profile
  );
  let auth0EmailHashed;
  if ((_d = (_c = payload == null ? void 0 : payload.properties) == null ? void 0 : _c.ids) == null ? void 0 : _d.auth0_email) {
    auth0EmailHashed = await hashEmail(payload.properties.ids.auth0_email);
  }
  const cerebroId = picked[EVENT_FIELDS.CEREBRO_PID] || payload.properties.cerebro_id;
  const browserId = getBrowserID();
  const visitId = (_e = payload.properties.ids) == null ? void 0 : _e.visit_id;
  return {
    ...picked,
    ...cerebroId && { [EVENT_FIELDS.CEREBRO_PID]: cerebroId },
    // don't add if undefined
    [EVENT_FIELDS.CLIENT_ID]: (_g = (_f = payload == null ? void 0 : payload.properties) == null ? void 0 : _f.ids) == null ? void 0 : _g.client_id,
    [EVENT_FIELDS.GA_CLIENT_ID]: cookies._ga,
    [EVENT_FIELDS.GA_SESSION_ID]: cookies._gid,
    [EVENT_FIELDS.LEAD_UUID]: leadId || payload.userId || payload.anonymousId,
    [EVENT_FIELDS.SESSION_ID]: (_i = (_h = payload == null ? void 0 : payload.properties) == null ? void 0 : _h.ids) == null ? void 0 : _i.session_id,
    [EVENT_FIELDS.BROWSER_ID]: browserId,
    [EVENT_FIELDS.AUTH0_EMAIL]: (_k = (_j = payload == null ? void 0 : payload.properties) == null ? void 0 : _j.ids) == null ? void 0 : _k.auth0_email,
    [EVENT_FIELDS.AUTH0_EMAIL_HASH]: auth0EmailHashed || void 0,
    [EVENT_FIELDS.AUTH0_USER_ID]: (_m = (_l = payload == null ? void 0 : payload.properties) == null ? void 0 : _l.ids) == null ? void 0 : _m.auth0_user_id,
    [EVENT_FIELDS.PERSON_ID]: (_o = (_n = payload == null ? void 0 : payload.properties) == null ? void 0 : _n.ids) == null ? void 0 : _o.person_id,
    [EVENT_FIELDS.PRODUCT_INTERACTION_ID]: (_q = (_p = payload == null ? void 0 : payload.properties) == null ? void 0 : _p.ids) == null ? void 0 : _q.product_interaction_id,
    [EVENT_FIELDS.PROFILE_ID]: (_s = (_r = payload == null ? void 0 : payload.properties) == null ? void 0 : _r.ids) == null ? void 0 : _s.profile_id,
    [EVENT_FIELDS.VISIT_ID]: visitId,
    [EVENT_FIELDS.MERKURY_CONFIDENCE_SCORE]: (_u = (_t = payload == null ? void 0 : payload.properties) == null ? void 0 : _t.ids) == null ? void 0 : _u.merkury_confidence_score,
    [EVENT_FIELDS.MERKURY_CMID]: (_w = (_v = payload == null ? void 0 : payload.properties) == null ? void 0 : _v.ids) == null ? void 0 : _w.merkury_cmid,
    [EVENT_FIELDS.MERKURY_HMID]: (_y = (_x = payload == null ? void 0 : payload.properties) == null ? void 0 : _x.ids) == null ? void 0 : _y.merkury_hmid
  };
};
export {
  extractIds
};
